import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {WarningComponent} from "../../warning/warning.component";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-department-id',
  templateUrl: './department-id.component.html',
  styleUrls: ['./department-id.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    WarningComponent,
    NgIf
  ]
})
export class DepartmentIdComponent implements OnInit, OnDestroy {

  private static readonly deptIdPattern = /^[0-9]{5}$/;

  @Output()
  deptIdEvent = new EventEmitter<{ valid: boolean, value: string }>();
  departmentForm: UntypedFormGroup;

  private subscription: Subscription;

  constructor(fb: UntypedFormBuilder) {
    this.departmentForm = fb.group({
      departmentControl: fb.control('', [Validators.pattern(DepartmentIdComponent.deptIdPattern), Validators.required]),
    });
  }

  ngOnInit(): void {
    this.subscription = this.departmentForm.controls.departmentControl.valueChanges
      .subscribe((updated: string) =>
        this.deptIdEvent.emit({valid: this.departmentForm.controls.departmentControl.valid, value: updated}));
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @Input()
  set deptId(deptId: string) {
    if (this.departmentForm.controls.departmentControl.value !== deptId) {
      this.departmentForm.controls.departmentControl.setValue(deptId);
    }
  }
}
